import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-dropdown" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "md-none" }
const _hoisted_5 = { class: "d-block fw-bold text-title" }
const _hoisted_6 = { class: "text-paragraph fs-14" }
const _hoisted_7 = { class: "dropdown-menu top-1 shadow-none border-0" }
const _hoisted_8 = { class: "list-style" }
const _hoisted_9 = { class: "fs-14 d-block transition text-dark fw-bold border-bottom pb-2 mb-2" }
const _hoisted_10 = { class: "fs-14 d-block transition" }
const _hoisted_11 = { class: "fs-14 d-block transition" }
const _hoisted_12 = { class: "fs-14 d-block transition" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "dropdown-toggle text-start text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false",
      "aria-label": _ctx.$t('profile')
    }, [
      _createElementVNode("img", {
        src: _ctx.getUserAvatar(),
        class: "profile-img",
        alt: _ctx.$t('profile'),
        style: {"width":"40px","height":"40px","object-fit":"cover"}
      }, null, 8, _hoisted_3),
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.userFullName), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.user ? (_ctx.user.username || _ctx.$t("header.user")) : _ctx.$t("header.please_login")), 1)
      ])
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.userFullName), 1),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/my-profile",
            class: "d-block"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("my_profile")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: "/system-settings",
            class: "d-block"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("system_settings")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("a", {
            href: "#",
            class: "d-block",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.$t("logout")), 1)
        ])
      ])
    ])
  ]))
}